
  <template>
    <div class="container">

      <div class="one">
        <span>二级单位</span>
        </div>
      <div class="two">
        <vue-seamless-scroll :data="List" :class-option="optionLeft" class="container-11" >
          <ul class="item">
            <li
              v-for="item in List"
              :key="item.id"
            >
              <img :src="item.thumbnail" alt="" @click="toWin(item.id)">
              <span>{{item.title}}</span>
            </li>
          </ul>
        </vue-seamless-scroll>
      </div>
    </div>

  </template>


<script>
export default {
  name: "Carousel",
  data () {
    return {
      List:[]
    }
  },
  props:{
    imgList:{
      type:Array
    }
  },
  watch:{
    imgList:function (){
      this.List=this.imgList[0].content
    }
  },
  methods:{
    toWin(id){
      this.$router.push(`/content/${id}`)
    }
  },
  computed: {
    optionLeft () {
      return {
        direction: 2,
        limitMoveNum: 2,
        hoverStop: true,
        step: 0.5
      }
    }
  }

}
</script>

<style scoped>

/*.el-carousel__item{*/
/*  width: 400px;*/
/*}*/

.container {
  background-color: white;
  /*box-sizing: border-box;*/
  display: flex;

  /*clear: both;*/
  /*border: 1px solid #d0d0d0;*/
  /*box-shadow: 1px 1px 4px #ccc;*/
}
.one{
  display: block;
  width: 30px;
  text-align: center;
}
.two{
  overflow: hidden;
  height: 190px;
  display: flex;
  padding: 0 20px 0 20px;
}
.one span{
  position: relative;
  top:46px;
  color: #088A29;
  font-weight: bold;
}
img{
 display: flex;
  margin: 0;
  padding: 0;
  width: 280px;
  height: 150px;
}
.item{
  display: flex;
  /* width: 1510px; */
}
li{
  float: left;
  margin-right: 22px;
  list-style-type: none;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/Carousel.vue